import LegalPage from "@/components/LegalPage";

const sections = [
  {
    heading: "1. Information We Collect",
    paragraphs: [
      "We may collect information you choose to submit through our website, such as your name, email address, phone number, company name, service interest, and any message you send through the contact form or newsletter form.",
      "We may also collect limited technical information such as browser type, device type, pages visited, referral source, and basic usage events when analytics cookies have been accepted.",
    ],
  },
  {
    heading: "2. How We Use Your Information",
    items: [
      "To respond to enquiries, discovery call requests, and newsletter signups.",
      "To understand how visitors use the website and improve content, navigation, and conversions.",
      "To maintain website security, performance, and abuse prevention.",
      "To comply with legal obligations or protect our rights where reasonably required.",
    ],
  },
  {
    heading: "3. Cookies, Analytics, and Local Storage",
    paragraphs: [
      "BitGenix uses essential browser storage to remember your cookie preference and support core website functionality.",
      "If you accept analytics cookies, we may use analytics tools such as Google Analytics and Microsoft Clarity to understand traffic patterns, page usage, on-site behavior, and website performance. If you decline, optional analytics should not be activated.",
    ],
  },
  {
    heading: "4. Forms and Third-Party Services",
    paragraphs: [
      "When you submit a form, your details may be processed through third-party services that help us operate the website and manage enquiries. This can include hosting providers, email providers, analytics providers, and tools such as Google Sheets or Google Workspace used for lead handling and internal operations.",
      "We do not sell your personal information. We only share information where necessary to run the website, deliver our services, or comply with law.",
    ],
  },
  {
    heading: "5. Data Retention",
    paragraphs: [
      "We retain enquiry, newsletter, and website records only for as long as reasonably necessary for business operations, legal compliance, record-keeping, or resolving disputes.",
      "If you want us to delete information you have submitted through the website, you may contact us and we will review the request in line with applicable obligations.",
    ],
  },
  {
    heading: "6. Your Choices",
    items: [
      "You may accept or decline analytics cookies through the cookie notice.",
      "You may unsubscribe from marketing emails at any time if such emails are sent.",
      "You may contact us to request correction or deletion of information you previously provided, subject to legal or operational requirements.",
    ],
  },
  {
    heading: "7. Security",
    paragraphs: [
      "We take reasonable administrative and technical steps to protect website data, but no online transmission or storage method can be guaranteed to be fully secure. You should avoid submitting highly sensitive confidential information through standard website forms unless specifically requested through a secure process.",
    ],
  },
  {
    heading: "8. Third-Party Links",
    paragraphs: [
      "This website may contain links to third-party websites, tools, or platforms. We are not responsible for the privacy practices, security, or content of external sites once you leave the BitGenix website.",
    ],
  },
  {
    heading: "9. Children's Privacy",
    paragraphs: [
      "The website is intended for adults and business users. We do not knowingly collect personal information from children.",
    ],
  },
  {
    heading: "10. Changes to This Policy",
    paragraphs: [
      "We may update this Privacy Policy from time to time to reflect operational, legal, or regulatory changes. The latest version posted on this page will apply from its listed update date.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="How BitGenix collects, uses, stores, and protects website information."
      path="/privacy-policy"
      updatedAt="March 31, 2026"
      intro="This Privacy Policy explains how BitGenix handles information collected through the website. It is a general website privacy notice covering enquiries, newsletter signups, analytics, and normal site use."
      sections={sections}
    />
  );
}
